export class RestoreRdsSubnetGroupsRdsSubnetGroupsInner {
    'name';
    'vpc';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpc",
            "baseName": "vpc",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreRdsSubnetGroupsRdsSubnetGroupsInner.attributeTypeMap;
    }
    constructor() {
    }
}
